import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Table
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import moment from 'moment';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {}
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    getTypeName = (type) => {
        let res = ""

        if (type == 1){
            res = "Seluruh Pegawai Tanpa Terkecuali";
        }
        else if (type == 2){
            res = "Seluruh Pegawai Dengan Pengecualian";
        }
        else if (type == 3){
            res = "Seluruh Pegawai Yang Melakukan Finger / Mobile";
        }

        return res
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid'), detail: 1 })
    }

    componentWillUnmount(){
        this.detailBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Pemutihan Absen</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Informasi Detail Pemutihan Absen
                                    </CardSubtitle> */}
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-2">
                                            Metode Pemutihan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.presensi_adjustment_type !== "" ? this.getTypeName(this.state.detail.presensi_adjustment_type) : '-'}</>
                                                : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-2">
                                            Deskripsi
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.presensi_adjustment_description !== "" ? this.state.detail.presensi_adjustment_description : '-'}</>
                                                : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-2">
                                            Tanggal Awal
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.presensi_adjustment_start_date !== "" ? this.dateParse(this.state.detail.presensi_adjustment_start_date) : '-'}</>
                                                : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-2">
                                            Tanggal Selesai
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.presensi_adjustment_end_date !== "" ? this.dateParse(this.state.detail.presensi_adjustment_end_date) : '-'}</>
                                                : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-2">
                                            Tanggal Proses
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.presensi_adjustment_create_date !== "" ? this.dateParse(this.state.detail.presensi_adjustment_create_date) : '-'}</>
                                                : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    {
                                        this.state.detail ?
                                            this.state.detail.presensi_adjustment_type == 2 ?
                                            <Row className="mb-3">
                                                <label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Daftar Pengecualian 
                                                </label>
                                                <Col md="8">
                                                    <Table className='table-striped'>
                                                        <thead>
                                                            <tr>
                                                                <td>No</td>
                                                                <td>NIP</td>
                                                                <td>Nama</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            this.state.detail?.employees.length > 0 ? 
                                                                this.state.detail?.employees.map((data, index) => {
                                                                    return (
                                                                        <tr>
                                                                            <td>{index+=1}</td>
                                                                            <td>{data.employee_nip}</td>
                                                                            <td>{data.employee_full_name}</td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            : 
                                                            <tr>
                                                                <td colSpan="3" className="text-center">Tidak Ada Data</td>
                                                            </tr>
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            : ""
                                        : 
                                            <Row className="mb-3">
                                                <label className="col-md-2"></label>
                                                <Col md="8">
                                                    <Shimmer><div style={{width: '100%', height: 30}}></div></Shimmer>
                                                </Col>
                                            </Row>
                                    }
                                    
                                    <Row className="mb-3">
                                        <Col md="2"></Col>
                                        <Col md="9">
                                            <Link to="?" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);